import { formatCurrency } from "@/lib/portfolioCalculations";

interface PortfolioSizeDisplayProps {
  portfolioSize: number;
}

const PortfolioSizeDisplay = ({ portfolioSize }: PortfolioSizeDisplayProps) => {
  return (
    <p className="text-2xl font-semibold text-navy">
      {formatCurrency(portfolioSize)}
    </p>
  );
};

export default PortfolioSizeDisplay;